// This file is part of re-motion
// Copyright (c) rubicon IT GmbH, www.rubicon.eu
// 

/**
 * Represents an error during a JSON-RPC call.
 * JsonRpcErrorCode defines common error scenarios.
 */
export type JsonRpcError = {
  code: number;
  message: string;
  data?: any;
};